import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { getOfflineProductColorPacksBasedOnAvailability } from '../../../../../database/offlineDatabase/types/offlineDatabaseProductColor.types';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class OfflinePackStockError extends Error {
  constructor() {
    super('stock is not enough for product color pack');
    this.name = 'OfflinePackStockError';
  }
}

export class ValidateProductColorPackStockRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    const allAppliedPacks = orderProduct.packs;

    if (!allAppliedPacks) {
      return;
    }

    const allProductColorPacks = getOfflineProductColorPacksBasedOnAvailability(
      orderProduct.productColor,
      orderProduct.availability,
    );

    const productColorPacksThatConsumeStock = allProductColorPacks.filter(
      (productColorPack) => productColorPack.willConsumeStock,
    );

    if (!productColorPacksThatConsumeStock.length) {
      return;
    }

    const allPacksAreValid = productColorPacksThatConsumeStock.every((productColorPack) => {
      const appliedPack = allAppliedPacks.find(
        (appliedPack) => appliedPack.pack.id === productColorPack.packId,
      );

      if (!appliedPack) {
        return true;
      }

      return appliedPack.multiplier <= productColorPack.stock.availableAmount;
    });

    if (!allPacksAreValid) {
      throw new OfflinePackStockError();
    }
  }
}
